import React from 'react';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Paper from '@material-ui/core/Paper/Paper';
import RefreshIcon from '@material-ui/core/SvgIcon/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import styles from '../styles';

const PaymentSourceTile = ({ account, onChangePaymentSource }) => {
  if (!account || !account.paymentSource) {
    return null;
  }

  const { paymentSource } = account;

  return (<Paper style={styles.paper}>
    <div style={styles.row}>
      <div style={styles.paperBodySmall}>
        <div style={styles.paperTitle}>Payment Source</div>
        <div>Type: {paymentSource.brand}</div>
        <div>Last 4: ...{paymentSource.last4}</div>
        <div>Expiry: {paymentSource.expiry.month}/{paymentSource.expiry.year}</div>
      </div>
      <div style={styles.actionButton}>
        <Tooltip placement="bottom" title="Change">
          <IconButton onClick={onChangePaymentSource}
          >
            <RefreshIcon style={styles.icon}/>
          </IconButton>
        </Tooltip>
      </div>
    </div>
  </Paper>);
};

export default PaymentSourceTile;



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingView/tiles/PaymentSourceTile.js